<template>
    <div>
        <p style="font-size: 18px; text-align: center; color: black;">Hola <strong>{{ name }}</strong>.</p>
        <p style="font-size: 18px; text-align: center; color: black;">Tienes una invitación <strong>{{ vehicular_type_location || access_types.includes(11) ? 'Vehicular' : 'Peatonal' }}:</strong></p>
        <form autocomplete="off" style="margin-top: 2rem;">
            <div style="margin-bottom: 3rem;" v-if="(this.vehicular_type_location || this.access_types.includes(11))">
                <div style="display: flex; justify-content: space-between; align-items: flex-end; height: 100%; margin-bottom: 0.5rem">
                    <label><strong>Ingrese Placa de Vehículo</strong></label>
                    <p></p>
                </div>
                <input style="width: 100%;"
                    v-model="form.plate_number"
                    placeholder="Ingresa la placa de tu vehículo"
                >
            </div>
            <label style="margin-bottom: 2rem; align-self: center;"><strong>Tomar foto selfie</strong></label>
            <div :class="['facial_access__upload_file', {'facial_access__border_error': step1Validated && !form.user_photo}]">
              <div v-if="!form.user_photo" @click="showCamera = true" style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 1rem 0; height: 100%;">
                <selfie-icon color="#757575"></selfie-icon>
              <p style="font-size: 18px; text-align: center;">Click Aquí <touch-icon color="#757575"></touch-icon></p>
              </div>
              <div v-else style="position: relative; display: flex; justify-content: center; align-items: center; height: 100%;">
                <img style="max-width: 240px; max-height: 240px; height: 98%;" :src="form.user_photo">
                <span @click="removeFile" style="position: absolute; top: 1rem; right: 0.5rem; width: 26px; height: 26px; display: flex; justify-content: center; align-items: center; border-radius: 50%; background-color: white; cursor: pointer">
                  <DeleteIcon :width="'25px'" :height="'25px'" :color="'#ffa1a1'" />
                </span>
              </div>
          </div>
        </form>

        <Transition name="fade">
      <CameraCapture
        :facial="false"
        class="facial_access__take_photo"
        v-if="showCamera"
        @captured="uploadGuestImage"
        @close="showCamera = false"  
        @camera="$emit('camera', $event)"
        :logo="logo"
      />
    </Transition>
    </div>
</template>

<script>

import SelfieIcon from '../icons/SelfieIcon.vue';
import SupplyIcon from '../icons/SupplyIcon.vue';
import TouchIcon from '../icons/TouchIcon.vue';
import CameraCapture from '../CameraCapture.vue';
import compressImage from '../../../utils/image-compresor';
import DeleteIcon from '../icons/DeleteIcon.vue';
import FacialAccessService from '../../../services/FacialAccessService';

export default {
    name: 'ResidentialView',
    components: {
        CameraCapture,
        SelfieIcon,
        TouchIcon,
        DeleteIcon,
        SupplyIcon,
    },
    props: {
        validation: Object,
        vehicular_type_location: Boolean,
        access_types: Array,
        name: String,
        basicData: Object,
        logo: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            form: {
                plate_number: '',
                user_photo: null,
            },
            formValidated: false,
            showCamera: false,
            step1Validated: false,
        }
    },
    methods: {
        async nextStep() {
            this.formValidated = true;
            if ((this.vehicular_type_location || this.access_types.includes(11))) {
                if (!this.form.plate_number || this.form.plate_number.length !== 6) {
                    alert("La placa del vehículo no es válida")
                    return;
                }
            }
            this.sendForm();
        },
        async uploadGuestImage(event) {
            this.showCamera = false;
            let vm = this;

            const guest_img = event.target.files[0];

            const blob = await compressImage(guest_img);

            const reader = new FileReader();

            reader.readAsDataURL(blob);

            reader.onload = () => {
                vm.form.user_photo = reader.result;
                vm.validation.firstStepValid = true;
            }
        },
        removeFile() {
            this.form.user_photo = null;
            this.validation.firstStepValid = false;
        },
        async sendForm() {
            this.$emit('loading', {value: 8, init: true, finish: false});
            this.basicData.rut = this.form.rut
            try {
                console.log({...this.form, ...this.basicData});
                
                const response = await FacialAccessService.validateAccess(this.encrypt({attributes: {...this.form, ...this.basicData}}).toString(), this.$http);
                if(response.status === 204 || response.status === 200) {
                  this.$emit("finish",true);
                  this.$emit('loading', {value: 2, init: false, finish: false});
                }

            } catch (e) {
                console.error(e);
                alert('Ha ocurrido un error al guardar la información')
            }
            this.$emit('loading', {value: 1, init: false, finish: true});
        }
    },
    mounted() {
        this.validation.maxSteeps = 1;
    },
    watch: {
        'form.plate_number' (newValue) {
            this.form.plate_number = this.form.plate_number.toUpperCase();
        }
    }
}
</script>